let zIndex = 2001

export function nextIndex() {
  return ++zIndex
}
